import { Create, SimpleForm, useNotify, useRedirect, useStore } from "react-admin";
import CreateFormFields from "./CreateFormFields";
import { SESSION_EXAMS_KEY } from "../List/List";
import BackButtonToolbar from "features/BackButtonToolbar";
import { AcademicSessionTypes, IntendedFor, SESSION_EXAMS, StudentServicePath } from "utils/constants";
import useConflictErrorModal from "server/components/Modals/useConflictErrorModal";
import { studentRequests } from "api/studentApi";
import { useNotifyError } from "utils/useNotifyError";
import dataProvider from "server/dataProvider";

const CreateSessionExam = () => {
  const [filters] = useStore(SESSION_EXAMS_KEY, {});
  const { handleConflictError, ConflictErrorDialog } = useConflictErrorModal();
  const notify = useNotify();
  const notifyError = useNotifyError();
  const redirect = useRedirect();

  const isWinterOrSummerSession =
    filters.academicYearSessionType === AcademicSessionTypes.SummerSession ||
    filters.academicYearSessionType === AcademicSessionTypes.WinterSession;

  const isExtendedSession =
    filters.academicYearSessionType === AcademicSessionTypes.ExtendedSession;

  const handleSave = async values => {
    const finalIntendedForValue = 
    isWinterOrSummerSession ? values.intendedFor :
    isExtendedSession ? IntendedFor.Individual : IntendedFor.OnlyNotPastExamsStudents;

    const commissions = values.commissions || [];
    const professors = commissions.flatMap((commission, commissionIndex) => {
      const commissionNumber = commission.commissionNumber || commissionIndex + 1;

      return (commission.professors || []).map(professor => ({
        professorEmployeeId: professor.professorEmployeeId,
        role: professor.role,
        commissionNumber,
      }));
    });

    const { commissions: _, ...rest } = values;

    const payload = {
      ...rest,
      intendedFor: finalIntendedForValue,
      academicYearSessionId: filters.academicYearSessionId,
      professors,
    };

    try {
      await dataProvider.customRequest(studentRequests.createSessionExam(), payload, "POST");
      notify("Записът е създаден", { type: "success" });
      redirect(-1);
    } catch (e) {
      notifyError(e);
      handleConflictError(e);
    }
  };

  return (
    <>
      <Create
        redirect={`/${StudentServicePath}${SESSION_EXAMS}`}
        title="Създаване на сесиен изпит"
        actions={<BackButtonToolbar />}
      >
        <SimpleForm onSubmit={handleSave}>
          <CreateFormFields
            filters={filters}
            isWinterOrSummerSession={isWinterOrSummerSession}
            isExtendedSession={isExtendedSession}
          />
        </SimpleForm>
      </Create>
      <ConflictErrorDialog />
    </>
  );
};
export default CreateSessionExam;
